import { Component } from '@angular/core';
import { LanguageSelectorComponent } from '../../common/components/language-selector/language-selector.component';

@Component({
  selector: 'app-footer',
  imports: [
    LanguageSelectorComponent,
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {

}
